import React from "react"
import LogoOcode from "./LogoOcode"
import LogoBicycode from "./LogoBicycode"
import LogoMFC from "./LogoMFC"
import LogoDecathlon from "./LogoDecathlon"
import { LogoMoustache } from "./LogoMoustache"

import { operators } from "utils/constants/operators"

const Logo = ({ name, className, style = {}, vertical = false, defaultColor = false }) => {

	// Get the default color of the given logo
	if (defaultColor) style["color"] = operators.find(o => o.id === name)?.theme?.primaryColor

	const renderIcon = (name) => {
	  switch(name) {
		case "bicycode":
			return <LogoBicycode className={className} style={style} />
		case "decathlon":
			return <LogoDecathlon className={className} style={style} />
		case "mc":
		case "moustache":
			return <LogoMoustache className={className} style={style} />
		case "mfc":
			return <LogoMFC className={className + (vertical ? " is-vertical" : "")} style={style} vertical={vertical} />
      default:
        return <LogoOcode className={className} style={style} />
    }
  }
	return renderIcon(name)
}

export default Logo
